import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/aquaart-group/src/views/about/index.tsx");
